<template>
  <main-layout>
    <template #header>
      <main-header :title="'거래처 관리' | translate" />
    </template>
    <template #feature>
      <div>
        <search-bar
            :placeholder="'검색어' | translate"
            v-model="selectOptions.searchKeyword"
            style="width: 250px;"
        />
      </div>
    </template>
    <template #toolbar>
      <search-group-sales :select-options.sync="selectOptions" />
    </template>
    <template #body>
      <no-library-bagic-table :table-body-data="tableBodyData"
                              :disable-button="disableButton"
                              @sort-option-change="sortOptionChange"
      />
      <div class="loading_wrap" v-show="isLoading">
        <div class="loading"></div>
        <div class="loading"></div>
        <div class="loading"></div>
      </div>
    </template>

  </main-layout>
</template>

<script>
/**
 * 거래처 관리 메뉴 클릭시 나오는 컴포넌트 입니다.
 */
import MainLayout from "@/components/common/layout/MainLayout";
import MainHeader from "@/components/common/layout/MainHeader";
import SearchBar from "@/components/input/SearchBar";
import SearchGroupSales from "@/views/accountManagement/SearchGroupSales";
import NoLibraryBagicTable from "@/views/accountManagement/NoLibraryBagicTable";
import{PATH} from "@/constants";
import {toCamel} from "snake-camel";

export default {
  name: "accountManagement",
  components: {
    MainLayout,
    MainHeader,
    SearchBar,
    SearchGroupSales,
    NoLibraryBagicTable
  },

  data() {
    return{
      selectOptions : this.formatSelectOptions(),
      isLoading:false,
      tableBodyData:[],
        // pageNumber:1, //추가로드를 위한 데이터입니다.
        disableButton:false//추가로드버튼 클릭은 막기 위함입니다.
    }
  },
  mounted() {
    const accountId = Number(this.$route.query.accountId || 0)
    const rentalcompanyId = Number(this.$route.query.rentalcompanyId || 0)
    if (!accountId) return
    if (rentalcompanyId > 0) this.selectOptions.rentalcompanyId = rentalcompanyId
    this.selectOptions.accountId = accountId
  },
  watch :{
    /**
     * select 박스 선택시 pageNumber는 계속 초기화 된다
     */
    selectOptions:{
      deep:true,
      handler() {
        this.pageNumber =1;
        this.tableDataLoad('');
      }
    },
    // pageNumber: {
    //   handler(newValue,oldValue){
    //     if(newValue<oldValue) return//pageNumber가 5인데 옵션을 선택시 중복 요청 방지
    //     this.tableDataLoad('pageDataAdd')
    //   }
    // }
  },

  methods : {
      /**
       * sorting 하는 함수입니다.
       * 데이터가 많을 경우 처리하는 속도가 느리기때문에 개선해야됩니다.
       *
       */
      sortOptionChange(e,selectOption,type) {
          this.tableBodyData.sort((a, b) => {
              let prev ,next ;
              if(type ==="number"){//숫자일때 비교
                  const numberA = Number(a[e])
                  const numberB = Number(b[e])
                  prev = numberA?numberA:0;
                  next = numberB?numberB:0;
              }else { //문자일때 비교
                  prev = a[e]?a[e].toUpperCase():'';
                  next = b[e]?b[e].toUpperCase():'';
              }
              if (prev < next) {//클때
                  return -1 * selectOption.sortOrder;
              }else if(prev > next) {//작을때
                  return 1 * selectOption.sortOrder;
              }else {//같을때
                  return 0;
              }
          });
      },
    /**
     * selctOptions 부분 데이터를 초기화 시켜주는 로직입니다.
     *
     */
    formatSelectOptions() {
      return {
        rentalcompanyId:undefined,
        accountId:undefined,
        contractFeeYn:undefined,
        billDayList:[],
        calculationStartdateList:[],
        taxSchDayList:[],
        statementIssueDayList:[],
        useYnList:[],
        deleteYn: "N",
        unpaidRequestYn:undefined,
        autoUseYn:undefined,
        autoUseCmsYn:undefined,
        autoUseTaxYn:undefined,
        autoUseStatementYn:undefined,
        searchKeyword:undefined,
        // pageSize:15
      }
    },
      // /**
      //  * 추가로드 버튼 클릭시 pageNumber 데이터를 1씩 증가합니다.
      //  */
      // pageNumberPlus(){
      //     this.pageNumber++
      // },
      /**
       * 응답받은 데이터가 없거나 테이블 자체에 데이터가 없을때 추가로드 버튼을 비활성화 합니다.
       * @param reqData
       */
      disableAddLoadButton(reqData){
          this.disableButton=!!reqData && !!reqData.length
      },
    /**
     *
     * @param name
     * @returns {Promise<void>}
     * selectOptions 데이터를 body에 담아 거래처 목록을 가져옵니다.
     * name은 pageNumber 변경시(추가로드 버튼 클릭시) 데이터 계속 저장 or 데이터 초기화
     * 부분을 선택합니다.
     * 응답 데이터가 스네이크 형식으로 와서 카멜형식으로 바꿔줘야됩니다.
     */
    async tableDataLoad(name) {
      this.isLoading=true;
      await this.$request(PATH.ACCOUNT.LIST)
          .setObject({
            ...this.selectOptions,
              // pageNumber: this.pageNumber
          }).catch((e)=>{
            this.isLoading =false;
            alert('조회실패')
          })
          .enqueue()
          .then(res => {
              this.disableAddLoadButton(res.data)
            const changeCamel = res.data.map((calData)=>{
              return  toCamel({...calData})
            })
            this.tableBodyData = name ? //추가로드 클릭시 데이터 추가저장
                [...this.tableBodyData,...changeCamel]
                :[...changeCamel]
              this.isLoading = false;
          });
    }

  },




}
</script>

<style scoped>
.loading_wrap {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  background: rgba(0,0,0,0.5);
}

.loading {
  width: 8px;
  height: 8px;
  background: #aaaaaa;
  border-radius: 50%;
  animation: loading-cricle 1.5s infinite ease-in-out;
  display: inline-block;
  margin-right: 8px;
}

.loading:nth-child(2) {
  animation-delay: .5s;
}

.loading:nth-child(3) {
  animation-delay: 1s;
}
@keyframes loading-cricle {
  0% {
    opacity: .4;
    transform: scale(1, 1);
  }
  50% {
    opacity: 1;
    transform: scale(1.2, 1.2);
  }
  100% {
    opacity: .4;
    transform: scale(1, 1);
  }
}
/*Search Box 부분 font 랑 사이즈 조정 부분입니다*/
>>> .v-input__control .v-input__slot .v-text-field__slot input{
  font-size: 11px;
  padding: 0;
}

>>> .v-input__control .v-input__slot fieldset{
  height: 47px;
}
</style>